module.exports = __webpack_public_path__ + "static/media/store-unavailable.9841cc4b.svg";